import { AdvancedSelect } from '@orobix/orobix-fe-components'
import { useTranslation } from 'react-i18next'

type ScenarioSelectorProps = {
  value: string
  onChange: (value: string) => void
  disabled?: boolean
  helpMessage?: string
  showLabel?: boolean
}

export const ScenarioSelector = ({
  value,
  onChange,
  disabled,
  helpMessage,
  showLabel = true,
}: ScenarioSelectorProps) => {
  const { t } = useTranslation()

  const VALID_SCENARIOS = [
    {
      value: 'Massimizzazione automazione',
      label: t('Maximization of automation'),
    },
    {
      value: 'Minimizzazione riempimenti',
      label: t('Minimization of refills'),
    },
    { value: 'Bilanciata', label: t('Balanced') },
    {
      value: 'Bilanciata & Max & Min',
      label: t('Balanced & Max & Min'),
    },
  ]

  return (
    <AdvancedSelect
      name="scenario"
      id="scenario"
      label={showLabel ? t('Scenario') : undefined}
      options={VALID_SCENARIOS}
      value={VALID_SCENARIOS.find((option) => option.value === value) || null}
      onChange={(option) => onChange(option?.value || '')}
      isDisabled={disabled}
      helpMessage={helpMessage}
    />
  )
}
